import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { useScreenWidth } from "hooks/useScreenWidth";
import { QueryParamProvider } from "providers/queryParams";
import { Outlet } from "react-router-dom";
import { CspViolationReporter } from "./components/CspViolationReporter";
import { PrevNextNavigationProvider } from "./components/PrevNextNavigation";
import { BreadcrumbProvider } from "./providers/breadcrumbs";
import { useEncampTheme } from "./theme";
import { SharedGoogleMapsProvider } from "./components/SharedGoogleMapsProvider";

export function App() {
  const { screenMaxWidth } = useScreenWidth();

  const encampTheme = useEncampTheme();

  return (
    <QueryParamProvider>
      <CspViolationReporter />
      <ThemeProvider theme={encampTheme}>
        <CssBaseline />
        <PrevNextNavigationProvider>
          <BreadcrumbProvider>
            <SharedGoogleMapsProvider>
              <Box sx={screenMaxWidth ? { maxWidth: screenMaxWidth } : {}}>
                <Outlet />
              </Box>
            </SharedGoogleMapsProvider>
          </BreadcrumbProvider>
        </PrevNextNavigationProvider>
      </ThemeProvider>
    </QueryParamProvider>
  );
}
